/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldsalesend3Inputs */

const en_ticketsfieldsalesend3 = /** @type {(inputs: Ticketsfieldsalesend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales until (optional)`)
};

const de_ticketsfieldsalesend3 = /** @type {(inputs: Ticketsfieldsalesend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkauf bis (freiwillig)`)
};

/**
* | output |
* | --- |
* | "Sales until (optional)" |
*
* @param {Ticketsfieldsalesend3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldsalesend3 = /** @type {((inputs?: Ticketsfieldsalesend3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldsalesend3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldsalesend3(inputs)
	return de_ticketsfieldsalesend3(inputs)
});
export { ticketsfieldsalesend3 as "ticketsFieldSalesEnd" }